import React, {useState, useCallback} from 'react';
import PropTypes from 'prop-types';

import useOnClickOutside from 'lib/hooks/useOnClickOutside';

import {Popover, TextField, Button} from '@albert-io/atomic';

const ZipcodeInput = ({
  popoverRef,
  showZipcodePopover,
  setShowZipcodePopover,
  setPostalcodeSearchValue,
  postalcodeSearchValue
}) => {
  const [localZipcode, setLocalZipcode] = useState(postalcodeSearchValue);
  const [hasError, setHasError] = useState(false);
  const [errorZip, setErrorZip] = useState('');

  useOnClickOutside(
    popoverRef,
    useCallback(
      () => !!showZipcodePopover && setShowZipcodePopover(false),
      [showZipcodePopover, setShowZipcodePopover]
    )
  );

  const checkZipcode = () => {
    // checks for 5 digits or {5}-{4} digits
    const zipcodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    const isValid = zipcodeRegex.test(localZipcode);
    if (isValid) {
      setPostalcodeSearchValue(localZipcode);
      setShowZipcodePopover(false);
    } else {
      setHasError(true);
      setErrorZip(localZipcode);
    }
  };

  return (
    <Popover
      expanded
      position='bottom-end'
      targetRef={popoverRef}
      zLevel='modal'
      modifiers={{
        preventOverflow: {
          boundariesElement: 'window'
        }
      }}
      usePortal={false}
    >
      <div className='u-display_flex u-flex-direction_column'>
        <TextField
          border
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              checkZipcode();
            }
          }}
          placeholder='Enter a ZIP code'
          onChange={(e) => setLocalZipcode(e.target.value)}
          value={localZipcode}
          error={hasError}
          message={hasError && `${errorZip} is not a valid zip code`}
        />

        <div className='u-display_flex u-justify-content_flex-end u-mar-t_2'>
          <Button
            color='secondary'
            variant='text'
            onClick={() => {
              setPostalcodeSearchValue(undefined);
              setShowZipcodePopover(false);
            }}
          >
            Clear
          </Button>
          <Button className='u-mar-l_1' onClick={checkZipcode}>
            Apply
          </Button>
        </div>
      </div>
    </Popover>
  );
};

ZipcodeInput.propTypes = {
  popoverRef: PropTypes.object,
  showZipcodePopover: PropTypes.bool,
  setShowZipcodePopover: PropTypes.func,
  setPostalcodeSearchValue: PropTypes.func,
  postalcodeSearchValue: PropTypes.number
};

export default ZipcodeInput;
